module.exports = __webpack_public_path__ + "static/media/my-confirm-list.98798fc1.svg";